import { useCallback } from "react";
import { Input } from "@/components/ui/input";
import { slotRegistry, type SlotEditorProps } from "../slot_registry.js";

function OnelineSlotEditor({ content, update }: SlotEditorProps) {
  const text = new TextDecoder().decode(content);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newContent = new TextEncoder().encode(e.target.value);
      update(newContent);
    },
    [update],
  );

  return (
    <Input
      value={text}
      onChange={handleChange}
      placeholder="Enter single line..."
      className="w-full"
    />
  );
}

slotRegistry.register({
  type: "oneline",
  component: OnelineSlotEditor,
});
